import { StringMap } from '@naturalcycles/js-lib'

export enum MixpanelEvent {
  DidChangeActiveDropInView = 'Did Change Active Drop In View',
  CouldNotEnterPaymentMethod = 'Could Not Enter Payment Method',
  EnteredPaymentMethod = 'Entered Payment Method',
  PaymentMethodRequested = 'Payment Method Requested',
  PaymentMethodRequestCompleted = 'Payment Method Request Completed',
  ClientPaymentAttempt = 'ClientPaymentAttempt',
  PaymentFailure = 'PaymentFailure',

  CouldNotRequestPaymentMethod = 'Could Not Request Payment Method',
  RedirectedToAddressPage = 'Redirected To Address Page',
  ToggledBillingAddress = 'Toggled Billing Address',
  EnteredAddress = 'Entered Address',
  AutofillAddress = 'AutofillAddress',
  OrderPlaced = 'Order Placed',
  ClickToPay = 'ClickToPay',
  ApplyDiscount = 'ApplyDiscount',
  InvalidDiscount = 'InvalidDiscount',
  RemoveDiscount = 'RemoveDiscount',
  WebClick = 'WebClick',
  GoalSelected = 'GoalSelected',
  DeviceSelected = 'DeviceSelected',
  ExcludedPassword = 'ExcludedPassword',
  InvalidLogin = 'InvalidLogin',
  InvalidEmail = 'InvalidEmail',
  ViewedModal = 'ViewedModal',
  HasOuraRing = 'HasOuraRing',
  HasAppleWatch = 'HasAppleWatch',
  IgnoredEmailVerification = 'IgnoredEmailVerification',
  DropinLoaded = 'DropinLoaded',
  ThreeDSecureModalRender = 'ThreeDSecureModalRender',
  ThreeDSecureModalClose = 'ThreeDSecureModalClose',
  ThreeDSecureLookupComplete = 'ThreeDSecureLookupComplete',
  CustomerCanceledThreeDSecureChallenge = 'CustomerCanceledThreeDSecureChallenge',
  ReceiptDownload = 'ReceiptDownload',
  OnboardingAnswer = 'OnboardingAnswer',
  OnboardingAutoModal = 'OnboardingAutoModal',
  RecaptchaFailed = 'RecaptchaFailed',
  WebSignupInit = 'WebSignupInit',
  EnteredEmailVerificationFlow = 'EnteredEmailVerificationFlow',
  DeviceRecommended = 'DeviceRecommended',
  EnteredPaymentRedirectFromAppFlow = 'EnteredPaymentRedirectFromAppFlow',
  NewsletterSignup = 'NewsletterSignup',

  // AB343
  CyclePhaseInfo = 'CyclePhaseInfo',
}

export enum CommonEvent {
  ClickToPay = 'ClickToPay',
  DeclineConsent = 'Decline registration consent',
}

export interface PageViewData extends StringMap {
  lang: string
  consentCookie: string | undefined
}

export interface CookieConsentContent {
  stamp: string
  necessary: boolean
  preferences: boolean
  statistics: boolean
  marketing: boolean
  ver: number
  utc: number
  region: string
}
